import { CaretDown } from "components/icons/CaretDown";
import React from "react";
import { CustomTaxOthersAccordion } from "./CustomAccordionComponents";
import { Button } from "components/DesignSystem/Button/Button";
import { useDispatch } from "react-redux";
import { openFloatingChat, setToOpenChatId } from "store/slices/chat";
import { useGetTaskQuery } from "store/apis/task";
import { openLink } from "utils/openLink";
import { INKLE_INCORPORATE_HELP } from "constants/resource";

const TAX_INCORPORATE_FAQS = [
  {
    question: "Can India-resident founders use this service?",
    answer:
      "Yes! India-resident founders should use the other tab to incorporate their US entity.",
  },
  {
    question: "Do I need a lawyer for incorporation?",
    answer:
      "No, our assisted service eliminates the need for expensive legal consultations. However, if you need legal advice, Clerky offers an optional attorney collaboration portal.",
  },
  {
    question: "What’s included in the incorporation service?",
    answer: (
      <ul>
        <li>Entity formation (Delaware C-Corp) </li>
        <li>EIN application (Employer Identification Number)</li>
        <li>Bank account setup</li>
        <li>Registered agent services</li>
        <li>Founder stock issuance</li>
        <li>Lifetime documentation & compliance support</li>
      </ul>
    ),
  },
  {
    question: "What are lifetime docs and post-incorporation maintenance?",
    answer:
      "These include ongoing compliance support, charter amendments, NDAs, foreign qualifications, and more, ensuring your business remains in good standing.",
  },
];

export const OtherFAQs = ({ taskId }: { taskId?: string }) => {
  const dispatch = useDispatch();
  const { data: task, isLoading } = useGetTaskQuery(
    { taskId: taskId! },
    { skip: !taskId }
  );

  const openTaskChannel = () => {
    if (task?.channel) {
      dispatch(setToOpenChatId(task.channel.channel_url));
      dispatch(openFloatingChat());
    }
  };

  if (isLoading) {
    return null;
  }

  return (
    <div className="t-mt-6">
      <div className="t-flex t-gap-20 t-bg-[url('static/images/TaxOthersFAQBG.svg')] t-bg-no-repeat t-bg-left-bottom t-p-6 t-rounded-lg t-border t-border-solid t-border-neutral-10">
        <div className="t-flex t-flex-col t-gap-6">
          <div className="t-text-subtitle-lg t-text-text-100">
            Frequently Asked Questions
          </div>
          <div className="t-w-fit t-flex t-flex-col">
            {task && (
              <Button size="small" onClick={openTaskChannel}>
                Doubts? Chat with us
              </Button>
            )}
            <div className="t-mt-2">
              <Button
                size="small"
                customType={task ? "link" : "secondary"}
                onClick={() => openLink(INKLE_INCORPORATE_HELP)}
              >
                Know more
              </Button>
            </div>
          </div>
        </div>
        <div className="t-flex-1 t-min-h-48">
          <CustomTaxOthersAccordion.Root
            type="single"
            defaultValue=""
            className="t-space-y-4"
            collapsible
          >
            {TAX_INCORPORATE_FAQS.map(({ question, answer }, i) => (
              <CustomTaxOthersAccordion.Item
                key={i}
                value={question}
                isLastItem={i === TAX_INCORPORATE_FAQS.length - 1}
              >
                <CustomTaxOthersAccordion.Trigger className="all:unset t-flex t-gap-2 t-group t-w-full">
                  <span className="t-flex t-gap-2 t-text-subtext-sm t-text-text-100 t-normal-case">
                    <span className="group-data-state-open:t-rotate-0 group-data-state-closed:-t-rotate-90 t-text-neutral t-transform t-transition t-duration-300 t-ease-in-out">
                      <CaretDown />
                    </span>
                    {question}
                  </span>
                </CustomTaxOthersAccordion.Trigger>
                <CustomTaxOthersAccordion.Content className="!t-p-0 t-mt-2 t-ml-6 t-text-body-sm t-text-text-30">
                  {answer}
                </CustomTaxOthersAccordion.Content>
              </CustomTaxOthersAccordion.Item>
            ))}
          </CustomTaxOthersAccordion.Root>
        </div>
      </div>
    </div>
  );
};
